import React from 'react';

import classNames from 'classnames';
import s from './PhotoCred.module.scss';

const PhotoCred = ({ credit, modifiers = [] }) => {
    if (!credit) return null;
    const classes = classNames(
        s['Root'],
        modifiers.map((m) => s[m])
    );
    return <span className={classes}>Photo: {credit}</span>;
};

PhotoCred.propTypes = {};

export default PhotoCred;
